module.exports = __webpack_public_path__ + "img/foundations-overview-banner.99806b3b.svg";